import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "newBeaconExportWhite",
  "use": "newBeaconExportWhite-usage",
  "viewBox": "0 0 11.98 9.592",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.98 9.592\" id=\"newBeaconExportWhite\"><path data-name=\"icon - download\" d=\"M5.98 0a.6.6 0 0 0-.59.607v4.544L4.017 3.777a.6.6 0 1 0-.847.847l2.4 2.4a.6.6 0 0 0 .847 0l2.4-2.4a.6.6 0 1 0-.847-.847L6.589 5.151V.607A.6.6 0 0 0 5.981 0zM.59 6.589a.6.6 0 0 0-.59.607v1.2a1.207 1.207 0 0 0 1.2 1.2h9.584a1.207 1.207 0 0 0 1.2-1.2v-1.2a.6.6 0 1 0-1.2 0v1.2H1.2v-1.2a.6.6 0 0 0-.608-.607z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol